const DISMISS = Symbol('DISMISS_TOAST');
const ADD = Symbol('ADD_TOAST');
const dismiss = toastId => {
    return {
        type: DISMISS,
        payload: toastId,
    };
};
const add = ({ message, variant }) => {
    return {
        type: ADD,
        payload: { message, variant },
    };
};
const actions = {
    add,
    dismiss,
};

export { ADD, DISMISS, actions };
